/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Pagination_PreviousInputs */

const es_feedback_pagination_previous = /** @type {(inputs: Feedback_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anterior`)
};

const en_feedback_pagination_previous = /** @type {(inputs: Feedback_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous`)
};

/**
* | output |
* | --- |
* | "Previous" |
*
* @param {Feedback_Pagination_PreviousInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_pagination_previous = /** @type {((inputs?: Feedback_Pagination_PreviousInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Pagination_PreviousInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_pagination_previous(inputs)
	return en_feedback_pagination_previous(inputs)
});
export { feedback_pagination_previous as "feedback.pagination.previous" }